import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import useAuthStore from '../store/useAuthStore';
import { toast } from 'react-toastify';
const GoogleCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { checkAuth } = useAuthStore();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    if (token) {
    toast.success('Google login successful!');

      Cookies.set('token', token, { expires: 7 });
      checkAuth(); // ✅ Update Zustand
      navigate('/'); // ✅ Redirect to homepage or dashboard
    } else {
      navigate('/login'); // Redirect to login if token is missing
    }
  }, [location, navigate, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center text-white">
      <h2 className="text-2xl">Logging you in via Google...</h2>
    </div>
  );
};

export default GoogleCallback;
